import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../../../api";
import { AxiosError } from "axios";
import { AttendanceLocalDepartmentGuicheService } from "../../../../../../@types/attendance-local-department-guiche-service";

export type AttendanceLocalDepartmentGuicheServiceCreateData = Pick<
    AttendanceLocalDepartmentGuicheService,
    | "guiche"
> & {
    servico: number;
}

export function useAttendanceLocalDepartmentGuicheServiceCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "department", "guiche", "service", "create"],
        mutationFn: async (data: AttendanceLocalDepartmentGuicheServiceCreateData) => {
            const response = await apisiseci.post<AttendanceLocalDepartmentGuicheService>(
                '/cms/servicos_guiches/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Serviço do guichê criado com sucesso!");

            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: ["attendance-local", "department", "guiche", "service", "list"],
                }),
                queryClient.invalidateQueries({
                    queryKey: ['attendance-local', 'service', 'list'],
                }),
            ]);
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error?.response?.data?.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
